import React from "react";
import Spinner from "react-bootstrap/Spinner";

const Loader = () => {
  return (
    <div className="loader">
      <div className="mb-3">Loading</div>
      <Spinner animation="border" />
    </div>
  );
};

export default Loader;
